import React from "react";
import ImagePath from "../../../packs_helper/scripts/ImagePath";
import ImageWithFallback from "../../Common/ImageWithFallback";
import Currency from "../../../packs_helper/scripts/Currency";
import DecimalFieldTag from "../../Common/DecimalFieldTag";
import PostData from "../../../packs_helper/scripts/PostData";
import GlobalVar from "../../GlobalVar";

const ProductRowMobile = (props) => {
	const [value, SetValue] = React.useState(1);

	const UpdatePrice = (value) => {
		SetValue(value);
	};

	const BuyProduct = () => {
		PostData(
			"/sepete-gonder",
			{
				id: props.product.id,
				quantity: value.toString(),
			},
			{ rawHtml: true }
		)
			.then((response) => {


				// this.setState({
				// });
			})
			.catch((err) => {


			});
	};

	let image, link;
	if(props.product.steam_item){
		image = `https://steamcommunity-a.akamaihd.net/economy/image/${props.product.steam_item.image}/420fx392f`;
		link = `/${props.product.category.slug}/${props.product.steam_item.slug}?id=${props.product.id}`;
	}
	else{
		image = props.product.image.replace('-thumb', '-medium')
		// image = ImagePath(
		// 					"products",
		// 					"images",
		// 					props.product.id,
		// 					"thumb",
		// 					props.product.image_file_name
		// 				);
		link = `/${props.product.category.slug}/${props.product.slug}`;
	}
	return (
		<div className="store-product-row">
			<a
				href={link}
				className="store-product-row-image"
				target="_blank"
			>
					<ImageWithFallback
						src={image}
						width={420}
						height={392}
					/>
			</a>
			<a
				href={link}
				target="_blank"
				className="store-product-row-name"
			>
				{props.product.name}{" "}
				<small>{props.product.package_name}</small>
			</a>
			<div className="store-product-row-price">
				{Currency(props.product.cost)} ₺
			</div>

			{props.kind === "sold-products" ? (
				<button className="btn btn-red" disabled={true}>
					Satıldı
				</button>
			) : (
				<div className="grid-2">
					<div className="input-with-label">
						<label>Adet:</label>
						<DecimalFieldTag onChange={UpdatePrice} value={value} />
					</div>

					<button onClick={BuyProduct} className="btn btn-jungle">
						Satın Al
					</button>
				</div>
			)}
		</div>
	);
};

export default ProductRowMobile;
